import { Injectable } from '@angular/core';
import { CwtApiService, CwtRequestConfig, mapPaginatedToArray } from '@cawita/core-front/api';
import { ClientAccess } from '@shared/models';
import { map } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ClientAccessAPI {
    constructor(private api: CwtApiService) { }
    
    public getMineClientAccesses(config?: CwtRequestConfig) {
        return this.api.get(`for-manager/client/access/mine`, {}, config).pipe(
            mapPaginatedToArray(),
            map(res => res.map(r => new ClientAccess(r)))
        );
    }
}